import React from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { CameraUpload } from '../components/CameraUpload';

export const UploadPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const handleUploadSuccess = () => {
    if (id) {
      navigate(`/gallery/${id}`);
    }
  };

  if (!id) {
    return (
      <div className="container mx-auto py-8 max-w-md">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Invalid Gallery</h1>
          <Button asChild>
            <Link to="/">Return to Home</Link>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto py-8 max-w-md">
      <div className="mb-6">
        <Button variant="outline" asChild>
          <Link to={`/gallery/${id}`}>← Back to Gallery</Link>
        </Button>
      </div>

      <div className="text-center mb-6">
        <h1 className="text-2xl font-bold mb-2">Upload Photos</h1>
        <p className="text-muted-foreground">
          Add photos to your gallery
        </p>
      </div>

      <CameraUpload galleryId={id} onSuccess={handleUploadSuccess} />
    </div>
  );
};
